import { parse } from "vue-currency-input";

export default {
  data() {
    return {
      cancellationMode: false,
      disableCancelSale: false,
      salesAdditiveType: "Cancelar Venda",
      productHasFee: false,
      totalFees: 0
    };
  },
  methods: {
    checkActive(value) {
      return value == 1 || value === true;
    },
    isEmptyOrInvalid(value) {
      return value == undefined || value == null || value == "";
    },
    validateProductsFee(productId, financesKeyBase) {
      let disable = false;

      const hasFineActive = this.checkActive(
        this.tempContract[`${financesKeyBase}${productId}_fine_fee_active`]
      );

      const hasSupplierFineActive = this.checkActive(
        this.tempContract[
        `${financesKeyBase}${productId}_supplier_fine_fee_active`
        ]
      );

      return (
        (hasFineActive &&
          this.isEmptyOrInvalid(
            this.tempContract[`${financesKeyBase}${productId}_fine_fee_value`]
          )) ||
        (hasSupplierFineActive &&
          this.isEmptyOrInvalid(
            this.tempContract[
            `${financesKeyBase}${productId}_supplier_fine_fee_value`
            ]
          )) ||
        disable
      );
    },
    verifySaleCancelation() {
      let disable = false;
      this.productHasFee = false;
      this.calcTotalFees();

      const contractedServices = JSON.parse(
        this.tempContract.contracted_services
      );

      // HOTEL
      if (contractedServices.includes("hotel")) {
        let hotelHasFee = false;
        const hotels = JSON.parse(this.tempContract["hotel_rows"]);
        const hotelFinances = `contract_finances_hotel_`;

        for (const hotel of hotels) {
          const hasFineActive = this.checkActive(
            this.tempContract[
            `${hotelFinances}${hotel.id}_fine_fee_active`
            ]
          );

          const hasSupplierFineActive = this.checkActive(
            this.tempContract[
            `${hotelFinances}${hotel.id}_supplier_fine_fee_active`
            ]
          );

          if (hasFineActive || hasSupplierFineActive) {
            this.productHasFee = true;
            if (hasFineActive && this.isEmptyOrInvalid(this.tempContract[`${hotelFinances}${hotel.id}_fine_fee_value`]) ||
              hasSupplierFineActive && this.isEmptyOrInvalid(this.tempContract[`${hotelFinances}${hotel.id}_supplier_fine_fee_value`])) {
              hotelHasFee = true
            }
          }
        }

        disable = hotelHasFee || disable;
      }

      // FLIGHT
      if (contractedServices.includes("flight")) {
        let flightHasFee = false;
        const flights = JSON.parse(this.tempContract["flight_sections_rows"]);
        const flightFinances = `contract_finances_flight_`;

        for (const flight of flights) {
          const hasFineActive = this.checkActive(
            this.tempContract[
            `${flightFinances}${flight.id}_fine_fee_active`
            ]
          );

          const hasSupplierFineActive = this.checkActive(
            this.tempContract[
            `${flightFinances}${flight.id}_supplier_fine_fee_active`
            ]
          );
       
          if (hasFineActive || hasSupplierFineActive) {
            this.productHasFee = true;
            if (hasFineActive && this.isEmptyOrInvalid(this.tempContract[`${flightFinances}${flight.id}_fine_fee_value`]) ||
              hasSupplierFineActive && this.isEmptyOrInvalid(this.tempContract[`${flightFinances}${flight.id}_supplier_fine_fee_value`])) {
              flightHasFee = true
            }
          }
        }

        disable = flightHasFee || disable;
      }

      // SERVICE
      if (contractedServices.includes("service")) {
        let serviceHasFee = false;
        const services = JSON.parse(this.tempContract["service_rows"]);
        const serviceFinances = `contract_finances_service_`;

        for (const service of services) {
          const hasFineActive = this.checkActive(
            this.tempContract[
            `${serviceFinances}${service.id}_fine_fee_active`
            ]
          );

          const hasSupplierFineActive = this.checkActive(
            this.tempContract[
            `${serviceFinances}${service.id}_supplier_fine_fee_active`
            ]
          );

          if (hasFineActive || hasSupplierFineActive) {
            this.productHasFee = true;
            if (hasFineActive && this.isEmptyOrInvalid(this.tempContract[`${serviceFinances}${service.id}_fine_fee_value`]) ||
              hasSupplierFineActive && this.isEmptyOrInvalid(this.tempContract[`${serviceFinances}${service.id}_supplier_fine_fee_value`])) {
              serviceHasFee = true
            }
          }
        }

        disable = serviceHasFee || disable;
      }
      
      this.disableCancelSale = disable;
    },
    calcTotalFees() {
      let total = 0;

      const contractedServices = this.tempContract[`contracted_services`]
        ? JSON.parse(this.tempContract[`contracted_services`])
        : [];

      const hotelRows = this.tempContract[`hotel_rows`]
        ? JSON.parse(this.tempContract[`hotel_rows`])
        : [];

      const serviceRows = this.tempContract[`service_rows`]
        ? JSON.parse(this.tempContract[`service_rows`])
        : [];

      const flightSectionsRows = this.tempContract[`flight_sections_rows`]
        ? JSON.parse(this.tempContract[`flight_sections_rows`])
        : [];

      const verifyValues = [1, "1", true];
      const feeTypes = ["change_tax", "fine_fee", "supplier_fine_fee"];

      // Calculate hotel fees
      if (contractedServices.includes("hotel")) {
        hotelRows.forEach((item) => {
          if (this.salesAdditiveType === "Cancelar Venda") {
            feeTypes.forEach((feeType) => {
              const isActive =
                this.tempContract[
                `contract_finances_hotel_${item.id}_${feeType}_active`
                ];
              if (verifyValues.includes(isActive)) {
                total += parse(
                  this.tempContract[
                  `contract_finances_hotel_${item.id}_${feeType}_value`
                  ]
                );
              }
            });
          } else {
            if (this.productsToCancel.includes(`hotel-${item.id}`)) {
              feeTypes.forEach((feeType) => {
                const isActive =
                  this.tempContract[
                  `contract_finances_hotel_${item.id}_${feeType}_active`
                  ];
                if (verifyValues.includes(isActive)) {
                  total += parse(
                    this.tempContract[
                    `contract_finances_hotel_${item.id}_${feeType}_value`
                    ]
                  );
                }
              });
            }
          }
        });
      }

      // Calculate service fees
      if (contractedServices.includes("service")) {
        serviceRows.forEach((item) => {
          if (this.salesAdditiveType === "Cancelar Venda") {
            feeTypes.forEach((feeType) => {
              const isActive =
                this.tempContract[
                `contract_finances_service_${item.id}_${feeType}_active`
                ];
              if (verifyValues.includes(isActive)) {
                total += parse(
                  this.tempContract[
                  `contract_finances_service_${item.id}_${feeType}_value`
                  ]
                );
              }
            });
          } else {
            if (this.productsToCancel.includes(`service-${item.id}`)) {
              feeTypes.forEach((feeType) => {
                const isActive =
                  this.tempContract[
                  `contract_finances_service_${item.id}_${feeType}_active`
                  ];
                if (verifyValues.includes(isActive)) {
                  total += parse(
                    this.tempContract[
                    `contract_finances_service_${item.id}_${feeType}_value`
                    ]
                  );
                }
              });
            }
          }
        });
      }

      // Calculate flight fees
      if (contractedServices.includes("flight")) {
        flightSectionsRows.forEach((item) => {
          if (this.salesAdditiveType === "Cancelar Venda") {
            feeTypes.forEach((feeType) => {
              const isActive =
                this.tempContract[
                `contract_finances_flight_${item.id}_${feeType}_active`
                ];
              if (verifyValues.includes(isActive)) {
                total += parse(
                  this.tempContract[
                  `contract_finances_flight_${item.id}_${feeType}_value`
                  ]
                );
              }
            });
          } else {
            if (this.productsToCancel.includes(`flight-${item.id}`)) {
              feeTypes.forEach((feeType) => {
                const isActive =
                  this.tempContract[
                  `contract_finances_flight_${item.id}_${feeType}_active`
                  ];
                if (verifyValues.includes(isActive)) {
                  total += parse(
                    this.tempContract[
                    `contract_finances_flight_${item.id}_${feeType}_value`
                    ]
                  );
                }
              });
            }
          }
        });
      }

      this.tempContract[`contract_cancellation_mode_total_fees_value`] = total;
      this.totalFees = total;

      return total;
    },
  }
}